import styled from 'styled-components';

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #f8fafc;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Sidebar = styled.aside`
  width: 320px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  overflow: auto;
  position: sticky;
  top: 0;
  height: 100vh;

  @media (max-width: 900px) {
    width: 300px;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    border-right: 1px solid #e2e8f0;
    border-bottom: none;
    max-height: none;
    z-index: 40;
    transform: translateX(${(p) => (p.$open ? '0' : '-100%')});
    transition: transform 200ms ease;
  }
`;

export const SidebarBackdrop = styled.button`
  display: none;

  @media (max-width: 900px) {
    display: ${(p) => (p.$open ? 'block' : 'none')};
    position: fixed;
    inset: 0;
    border: none;
    background: rgba(15, 23, 42, 0.35);
    z-index: 30;
    cursor: pointer;
  }
`;

export const SidebarHeader = styled.div`
  padding: 18px 18px 14px;
  border-bottom: 1px solid #e2e8f0;
`;

export const SidebarTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: #0f172a;
`;

export const LangRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
`;

export const LangButton = styled.button`
  border: 1px solid #e2e8f0;
  background: ${(p) => (p.$active ? '#0b1220' : '#ffffff')};
  color: ${(p) => (p.$active ? '#e2e8f0' : '#0f172a')};
  padding: 8px 10px;
  border-radius: 12px;
  cursor: pointer;
  font-size: 12px;
  flex: 0 0 auto;

  &:hover {
    border-color: #94a3b8;
  }
`;

export const SearchBox = styled.div`
  padding: 12px 18px 14px;
  border-bottom: 1px solid #e2e8f0;
`;

export const SearchInput = styled.input`
  width: 100%;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 10px 12px;
  font-size: 14px;
  outline: none;
  background: #ffffff;

  &:focus {
    border-color: #94a3b8;
  }
`;

export const NavGroupTitle = styled.div`
  padding: 14px 18px 8px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #64748b;
  letter-spacing: 0.08em;
`;

export const NavSectionTitle = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px 6px;
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`;

export const NavSubGroupTitle = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 18px 6px;
  padding-left: 32px;
  font-size: 12px;
  font-weight: 700;
  color: #475569;
  background: transparent;
  border: none;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`;

export const NavChevron = styled.span`
  font-size: 12px;
  color: #94a3b8;
  transform: rotate(${(p) => (p.$open ? '90deg' : '0deg')});
  transition: transform 140ms ease;
  line-height: 1;
`;

export const NavItem = styled.button`
  width: 100%;
  text-align: left;
  padding: 10px ${(p) => 18}px;
  padding-left: ${(p) => 18 + (p.$indent || 0) * 14}px;
  border: none;
  background: ${(p) => (p.$active ? '#f1f5f9' : 'transparent')};
  color: ${(p) => (p.$active ? '#0f172a' : '#334155')};
  border-left: 3px solid ${(p) => (p.$active ? '#ef4444' : 'transparent')};
  cursor: pointer;
  font-size: 14px;

  &:hover {
    background: #f8fafc;
  }
`;

export const Page = styled.div`
  color: #0f172a;
`;

export const Container = styled.div`
  flex: 1;
  max-width: 980px;
  margin: 0 auto;
  padding: 24px 16px 80px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 18px;
`;

export const MobileTopBar = styled.div`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    gap: 10px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 10px 12px;
    position: sticky;
    top: 0;
    z-index: 20;
  }
`;

export const BurgerButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
`;

export const Subtitle = styled.div`
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
`;

export const HeaderLinks = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 2px;
`;

export const HeaderLinkButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #0f172a;
  font-size: 13px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    border-color: #94a3b8;
    background: #f8fafc;
  }
`;

export const Section = styled.section`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  padding: 18px;
  margin-top: 14px;
`;

export const SectionTitle = styled.h2`
  margin: 0 0 10px;
  font-size: 18px;
  line-height: 1.3;
`;

export const Text = styled.p`
  margin: 8px 0;
  color: #0f172a;
  line-height: 1.55;
  font-size: 14px;
`;

export const List = styled.ul`
  margin: 8px 0 0;
  padding-left: 18px;
  color: #0f172a;
  line-height: 1.55;
  font-size: 14px;
`;

export const InlineCode = styled.code`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  padding: 2px 6px;
  border-radius: 8px;
  font-size: 12px;
`;

export const CodeCard = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 10px;
`;

export const CodeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  background: #0b1220;
  color: #e2e8f0;
  font-size: 12px;
`;

export const CopyButton = styled.button`
  border: 1px solid rgba(226, 232, 240, 0.35);
  background: rgba(15, 23, 42, 0.4);
  color: #e2e8f0;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 12px;

  &:hover {
    background: rgba(15, 23, 42, 0.7);
  }
`;

export const Code = styled.pre`
  margin: 0;
  padding: 12px 12px;
  background: #0b1220;
  color: #e2e8f0;
  overflow: auto;
  font-size: 12px;
  line-height: 1.55;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
`;

